'use client';

import { c as _c } from "react/compiler-runtime";
import { Pagination } from '@heroui/react';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
interface DefaultListFooterProps extends Omit<ComponentProps<'div'>, 'children'> {
  totalPages: number;
  page: number;
  setPage: (page: number) => void;
}
export default function DefaultListFooter(t0) {
  const $ = _c(25);
  let className;
  let page;
  let props;
  let setPage;
  let totalPages;
  if ($[0] !== t0) {
    ({
      page,
      setPage,
      totalPages,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = page;
    $[3] = props;
    $[4] = setPage;
    $[5] = totalPages;
  } else {
    className = $[1];
    page = $[2];
    props = $[3];
    setPage = $[4];
    totalPages = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("sticky bottom-0 z-20 flex w-full bg-background rounded-t-3xl items-center justify-center p-4", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== setPage) {
    t2 = e => setPage(e);
    $[8] = setPage;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== page || $[11] !== t2 || $[12] !== totalPages) {
    t3 = <Pagination size="lg" total={totalPages} initialPage={1} showControls={true} showShadow={true} page={page} onChange={t2} color="primary" className="hidden sm:flex" />;
    $[10] = page;
    $[11] = t2;
    $[12] = totalPages;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== setPage) {
    t4 = e_0 => setPage(e_0);
    $[14] = setPage;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== page || $[17] !== t4 || $[18] !== totalPages) {
    t5 = <Pagination size="lg" total={totalPages} initialPage={1} siblings={0} showControls={true} showShadow={true} page={page} onChange={t4} color="primary" className="flex sm:hidden" />;
    $[16] = page;
    $[17] = t4;
    $[18] = totalPages;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== props || $[21] !== t1 || $[22] !== t3 || $[23] !== t5) {
    t6 = <div className={t1} {...props}>{t3}{t5}</div>;
    $[20] = props;
    $[21] = t1;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}